import React, { useEffect, useState } from 'react';
import axios from 'axios';
import authHeader from "../services/AuthHeader";
import TableDisplay from './TableDisplay';
import { Button } from 'react-bootstrap';
import EditPartyModal from './EditPartyModal';
import DeletePartyModal from './DeletePartyModal';
import { useHistory } from "react-router-dom";

const ManageParty = (props) => {
    let history = useHistory();
    const initUser ={
            starId: '',
            firstName: '',
            lastName: '',
            email: ''
        };
    const [displayUsers, setDisplayUsers] = useState([]);
        
    const heading = ["Party Name"];
    
    const [modalShow, setModalShow] = useState(false);
    const [modalDeleteShow, setModalDeleteShow] = useState(false);
    
    const [user, setUser] = useState(initUser);
    
    const [mode, setMode] = useState("");
    const [rerender, setRerender] = useState(false);
    
    const modalHide = ()=>{  
        setModalShow(false);
    }
    
    const showModal = ()=>{
        setModalShow(true)
    }
    
    const modalDeleteHide = ()=>{   
        setModalDeleteShow(false);
    }
    
    const showDeleteModal = ()=>{
        setModalDeleteShow(true)
    }
        
    useEffect(()=>{
        axios.get(
            process.env.REACT_APP_API_BASE + 'party/',{ headers: authHeader() }
          )
        .then(res=>{
            let unitList = res.data.map((val,i)=>{
                return(<>
                <tr key={val.starId}>
                    <td key='0' width="95%">{val.ballotCandidatePartyName}</td>

                     <td key='4' width="8%">
                        <Button key={'edit_'+val.ballotCandidatePartyId} className = 'btn btn-default' 
                        onClick={() => 
                            {
                            setMode("EDIT")
                            showModal()
                            setUser(val)
                            }
                            }>Edit</Button>
                    </td> 
                    <td key='5' width="5%">
                        <Button key={'delete_'+val.ballotCandidatePartyId} className = 'btn btn-default' 
                        onClick={() => 
                            {
                            setMode("DELETE")
                            showDeleteModal()
                            setUser(val)
                            }
                            }>REMOVE</Button>
                    </td>
                                   
                </tr>
                </>);
            });
            setDisplayUsers(unitList);
            setRerender(false);
        });   
    }, [rerender]);

return  (<>
    <h1 className='h2'>Manage Parties</h1>
    <TableDisplay tableHeading = {heading} tableData = {displayUsers}/>
    <EditPartyModal mode = {mode} show = {modalShow} user= {user}
     onHide = {modalHide} setRerender={setRerender}
    />
    <DeletePartyModal mode = {mode} show = {modalDeleteShow} user= {user}
     onHide = {modalDeleteHide} setRerender={setRerender}
    />
    <Button className="btn btn-default" type="button" onClick = {()=> {
                                                    setUser(initUser)
                                                    showModal()
                                                    setMode("ADD")}}>Add new {[props.unitType]}</Button>
    <Button style={{marginLeft: '20px'}} className="btn btn-default" type="button" onClick={() => history.goBack()}>Back</Button>
    <br />   
</>); 
}

export default ManageParty;
